import { FolderType } from '../types';

export const FOLDER_BOX_W = 300;
export const FOLDER_BOX_H = 200;
export const FOLDER_GAP = 15;
export const CELL_W = FOLDER_BOX_W + FOLDER_GAP;
export const CELL_H = FOLDER_BOX_H + FOLDER_GAP;
export const GRID_ORIGIN_X = 20;
export const GRID_ORIGIN_Y = 20;

export function snapToGrid(x: number, y: number): { x: number; y: number } {
  const col = Math.round((x - GRID_ORIGIN_X) / CELL_W);
  const row = Math.round((y - GRID_ORIGIN_Y) / CELL_H);
  return {
    x: Math.max(0, GRID_ORIGIN_X + col * CELL_W),
    y: Math.max(0, GRID_ORIGIN_Y + row * CELL_H),
  };
}

function rectsOverlap(
  ax: number, ay: number, aw: number, ah: number,
  bx: number, by: number, bw: number, bh: number,
): boolean {
  return ax < bx + bw && ax + aw > bx && ay < by + bh && ay + ah > by;
}

export function findFreePosition(
  x: number, y: number,
  excludeId: string,
  folders: FolderType[],
): { x: number; y: number } {
  const snapped = snapToGrid(x, y);
  x = snapped.x;
  y = snapped.y;

  const taken = (px: number, py: number) =>
    folders.some(
      (f) =>
        f.id !== excludeId &&
        rectsOverlap(px, py, FOLDER_BOX_W, FOLDER_BOX_H, f.position.x, f.position.y, FOLDER_BOX_W, FOLDER_BOX_H),
    );

  if (!taken(x, y)) return { x, y };

  for (let row = 0; row < 100; row++) {
    const rowY = GRID_ORIGIN_Y + row * CELL_H;
    for (let col = 0; col < 100; col++) {
      for (const sign of [1, -1]) {
        const colX = x + col * CELL_W * sign;
        if (colX < GRID_ORIGIN_X) continue;
        if (!taken(colX, rowY)) return { x: colX, y: rowY };
      }
    }
  }

  const maxY = GRID_ORIGIN_Y + folders.length * CELL_H;
  return { x: GRID_ORIGIN_X, y: maxY };
}
